<template functional>
  <div class="scroll-down-sign">
    <svg class="scroll-down-sign__first" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
      <defs>
        <clipPath><path fill="#00f" fill-opacity=".514" d="m-7 1024.36h34v34h-34z" /></clipPath>
        <clipPath>
          <path fill="#aade87" fill-opacity=".472" d="m-6 1028.36h32v32h-32z" />
        </clipPath>
      </defs>
      <path
        d="m345.44 248.29l-194.29 194.28c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744l171.91-171.91-171.91-171.9c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.29 194.28c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373"
        transform="matrix(.03541-.00013.00013.03541 2.98 3.02)"
        fill="#4d4d4d"
      />
    </svg>
    <svg class="scroll-down-sign__second" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
      <defs>
        <clipPath><path fill="#00f" fill-opacity=".514" d="m-7 1024.36h34v34h-34z" /></clipPath>
        <clipPath>
          <path fill="#aade87" fill-opacity=".472" d="m-6 1028.36h32v32h-32z" />
        </clipPath>
      </defs>
      <path
        d="m345.44 248.29l-194.29 194.28c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744l171.91-171.91-171.91-171.9c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.29 194.28c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373"
        transform="matrix(.03541-.00013.00013.03541 2.98 3.02)"
        fill="#ff0000"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ScrollDownSign'
};
</script>

<style lang="scss" scoped>
.scroll-down-sign {
  display: flex;
  flex-direction: column;

  &__first {
    width: 32px;
    transform: rotate(90deg);

    path {
      fill: var(--u-color-grey-900);
      animation: 0.6s blink-first infinite;
    }
  }

  &__second {
    width: 32px;
    transform: translateY(-18px) rotate(90deg);

    path {
      fill: var(--u-color-grey-400);
      animation: 0.6s blink-second infinite;
    }
  }
}

@keyframes blink-first {
  0% {
    fill: var(--u-color-grey-900);
  }

  25% {
    fill: var(--u-color-grey-700);
  }

  50% {
    fill: var(--u-color-grey-400);
  }

  75% {
    fill: var(--u-color-grey-600);
  }

  100% {
    fill: var(--u-color-grey-900);
  }
}

@keyframes blink-second {
  0% {
    fill: var(--u-color-grey-400);
  }

  25% {
    fill: var(--u-color-grey-600);
  }

  50% {
    fill: var(--u-color-grey-900);
  }

  75% {
    fill: var(--u-color-grey-600);
  }

  100% {
    fill: var(--u-color-grey-400);
  }
}
</style>
